import React, {useState, useEffect} from 'react'
import '../css/header.css'
import { Outlet, Link } from "react-router-dom";
import destinos from '../assets/images/menu-icons/destinos.svg'
import viajeGrupo from '../assets/images/menu-icons/viajegrupo.svg'
import conexion from '../assets/images/menu-icons/conexion-global.png'
import bfpass from '../assets/images/menu-icons/pasaporte.png'

import preparaTuViaje from '../assets/images/menu-icons/PreparaTuViaje.svg'
import preguntasFrecuentes from '../assets/images/menu-icons/preguntas-frecuentes.svg'
import nuestraFlota from '../assets/images/menu-icons/nuestraflota.svg'
import contacto from '../assets/images/menu-icons/ContactaAsesor.svg'
import cargaImg from '../assets/images/menu-icons/contenedor.svg'

import carga from '../assets/images/soluciones/btn-carga.svg'

import informacion from '../assets/images/menu-icons/informacion.svg'

import rutasyhorarios from '../assets/images/menu-icons/rutasyhorarios.svg'
import tarifas from '../assets/images/menu-icons/tarifas.svg'
import promociones from '../assets/images/menu-icons/promociones.svg'
import viaja from '../assets/images/menu-icons/viaja.svg'
import itinerario from '../assets/images/menu-icons/itinerario.svg'

import facebook_icon from '../assets/images/grises/facebook-gris.svg'
import instagram_icon from '../assets/images/grises/instagram-alt-circle-gris.svg'
import spotify_icon from '../assets/images/grises/spotify-gris.svg'
import twitter_icon from '../assets/images/grises/twitter-alt-circle-gris.svg'
import whatsapp_icon from '../assets/images/grises/whatsapp-grises.svg'
import youtube_icon from '../assets/images/grises/youtube-alt-circle-blanco.svg'
import { useTranslation } from 'react-i18next';
import facebook_icon_blue from '../assets/images/menu-icons-cel/facebook-blue.png'
import instagram_icon_blue from '../assets/images/menu-icons-cel/instagram-alt-circle-blue.png'
import spotify_icon_blue from '../assets/images/menu-icons-cel/spotify-blue.png'
import twitter_icon_blue from '../assets/images/menu-icons-cel/twitter-alt-circle-blue.png'
import whatsapp_icon_blue from '../assets/images/menu-icons-cel/whatsapp-blue.png'
import youtube_icon_blue from '../assets/images/menu-icons-cel/youtube-alt-circle-blue.png'

export default function Header() {
    const [isSubmenu, setIsSubmenu] = useState(false);
    const [isAviso] = useState(true);
    const [isActive, setActive] = useState(false);
    const [lateralMenu, setLateralMenu] = useState(false);
    const [scroll, setScroll] = useState(false);
    const { i18n } = useTranslation();
    const { t } = useTranslation('header');
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);            

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setCurrentLanguage(language); // Actualizar estado
    };

    const [dropdown, setDropdown] = useState(false);

    const toggleDropdown = (index) => {      
        console.log("Anterior", dropdown);
        setDropdown((prevState) => (prevState === index ? null : index));
        console.log("Nuevo", dropdown);
    };
    
    useEffect(() => {
        const handleScroll = () => {
        const isScrolled = window.scrollY > 20; // Cambia este valor según tus necesidades
        if (isScrolled !== scroll) {
            setScroll(isScrolled);
        }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
    
    }, [scroll]);
    const toggleSubmenu = (index) => {
        setIsSubmenu((prevState) => (prevState === index ? null : index));
    };
    const closeSubmenu = () => {

        setIsSubmenu(false); 
       // console.log("Anterior", isActive );
        setActive(false);
       // console.log("Nuevo", isActive );
        setLateralMenu(false);
    };
    const toggleMenuExpanded = () => {
        setActive(!isActive);  
    };
    const toggleLateralMenu = () => {   
        console.log("anterior: ", lateralMenu);     
        setLateralMenu(!lateralMenu);
        console.log("Nuevo: ", lateralMenu);
    };

  return (
    <>
    {isAviso &&(
        <>
            <section className='avisoHeader' style={{ background: '#007bff', color: '#fff'}}>
                <div className='container'>
                    <div className='avisoHeader_content'>
                        <p style={{color:'#fff'}}> {t('aviso2')}</p>
                    </div>
                </div>
            </section>
            {/*<section className='avisoHeader' style={{ background: '#007bff', color: '#fff'}}>*/}
            <section className='avisoHeader' style={{ background: '#FFBE00', color: '#343434'}}>
                <div className='container'>
                    <div className='avisoHeader_content'>                 
                        <p style={{color:'#343434'}}><strong>{t('titulo_aviso')} </strong>: {t('aviso')}</p>
                        {/*<p style={{color:'#343434'}}><strong>{t('titulo_aviso')} </strong>: La salida de la ruta La Paz–Mazatlán en el buque Cabo Star está programada para las 19:20 hrs. Te recomendamos llegar con anticipación.</p>*/}
                        
                        {/*<label> <Link to="/aviso" className="btn_aviso_cintillo" style={{color: '#fff', border: '2px solid #fff'}}>Ver más</Link> </label>                    */}
                    </div>                
                </div>
            </section>
        </>
    )}

    <header>
        <div className='header-top'>
            <div className='container'>
                <div className='header-top-content'>
                    <a href="tel:8003377437" target="_blank" rel="noopener noreferrer"><i class="fi fi-ss-circle-phone"></i> 800 337 74 37 </a>  
                    <div className='header-top-box'>
                        <a href="https://facturacion.bajaferries.com" target="_blank" rel="noopener noreferrer"> {t('lateral_menu18')}  <i class="fi fi-rs-arrow-up-right-from-square"></i></a>                      
                        <a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu19')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>                      
                    </div>
                </div>
            </div>
        </div>
        
        <div className={`main-header ${scroll ? "scrolled" : null}`}>
            <div className='container'>
                <div className='main-header-content'>
                    
                    <Link to="/" aria-label="logo Baja Ferries"> <div className='logo'></div></Link>
                    <div className='header-item-list'>
                        <ul>
                            <li><Link to="/rutas_horario"> {t('opc1')}</Link></li>
                            <li><Link to="/tarifas">{t('opc2')}</Link></li>
                            <li><Link to="/promociones">{t('opc3')} </Link></li>                         
                            
                            <li><Link onClick={() => toggleSubmenu(1)}>{t('opc4')} <i class="fi fi-br-angle-small-down" ></i> </Link>
                                {isSubmenu === 1 &&(
                                <div className='submenu-item '>
                                    <ul className={`submenu-ite ${isSubmenu ? 'submenu-item-open' : ''}`}>
                                        <div className='submenu-description'>
                                            
                                            <div className='submenu-box-title'>
                                                <h3>{t('opc4')}</h3>
                                                <p>{t('description1')}</p>
                                            </div>                                          
                                        </div>
                                        <div className='submenu-description'>
                                            <li><Link to="/destinos" >
                                                <div className='submenu-description-content'>
                                                    <img src={destinos} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>                                                                                                               
                                                        <h2>{t('submenu1')}</h2>
                                                        <p>{t('description2')}</p>
                                                    </div>                                               
                                                </div> 
                                            </Link></li>
                                            <li><Link to="/viaje-en-grupo">
                                                <div className='submenu-description-content'>
                                                    <img src={viajeGrupo} alt='destinos'/>                                                                                                            
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('submenu2')}</h2>
                                                        <p>{t('description3')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> 
                                            </li>
                                            <li>    
                                                <Link to="/conecta-tu-trayecto">
                                                    <div className='submenu-description-content'>
                                                        <img src={conexion} alt='destinos'/>                                                                                                            
                                                        <div className='submenu-description-box'>
                                                            <h2>Conecta tu viaje</h2>
                                                            <p>Más opciones de transporte terrestre</p>
                                                        </div>
                                                    </div>                                               
                                                </Link> 
                                            </li>
                                            {/*<li>    
                                                <Link to="/bf-pass">
                                                    <div className='submenu-description-content'>
                                                        <img src={bfpass} alt='destinos'/>                                                                                                            
                                                        <div className='submenu-description-box'>
                                                            <h2 className='nuevo-item'>BF PASS</h2>
                                                            <p>Tu acceso al Mar de Cortés</p>
                                                        </div>
                                                    </div>                                               
                                                </Link> 
                                            </li>*/}
                                        </div>
                                        <div className='submenu-description'>                                        
                                            {/*<img src={viaja} alt='viaja'/>  */}  
                                            <div className='viaja'></div>  
                                        </div>
                                    </ul>
                                </div>
                                )}
                               
                            </li>
                            <li><Link onClick={() => toggleSubmenu(2)} >{t('opc5')} <i class="fi fi-br-angle-small-down"></i></Link>
                                {isSubmenu === 2 &&(
                                <div className='submenu-item'>
                                    <ul className={`submenu-ite ${isSubmenu ? 'submenu-item-open' : ''}`}>
                                        <div className='submenu-description'>                                            
                                            <div className='submenu-box-title'>
                                                <h3>{t('opc5')}</h3>
                                                <p>{t('description4')}</p>
                                            </div>                                          
                                        </div>
                                        <div className='submenu-description'>
                                            <li><Link to="/prepara-tu-viaje" >
                                                <div className='submenu-description-content'>
                                                    <img src={preparaTuViaje} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>{t('submenu3')}</h2>
                                                            <p>{t('description5')}</p>
                                                        </div>
                                                       
                                                    </div>
                                                </div> 
                                            </Link></li>
                                            <li><Link to="/preguntas-frecuentes">
                                                <div className='submenu-description-content'>
                                                    <img src={preguntasFrecuentes} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('lateral_menu12')}</h2>
                                                        <p>{t('description6')}</p>
                                                    </div>
                                                </div>
                                            </Link> </li>
                                            <li>
                                                <Link to="/flota" >
                                                <div className='submenu-description-content'>
                                                    <img src={nuestraFlota} alt='destinos'/>                                                    
                                                    <div className='submenu-description-box'>
                                                        <div>                                                        
                                                            <h2>{t('submenu5')}</h2>
                                                            <p>{t('description7')}</p>
                                                        </div>                                                       
                                                    </div>
                                                </div> 
                                            </Link>
                                            </li>
                                            <li><Link to="/contacto">
                                                <div className='submenu-description-content'>
                                                    <img src={contacto} alt='destinos'/>
                                                    <div className='submenu-description-box'>
                                                        <h2>{t('submenu6')}</h2>
                                                        <p>{t('description8')}</p>
                                                    </div>
                                                </div>                                               
                                            </Link> </li>
                                        </div>
                                        <div className='submenu-description'>                                        
                                            {/*<img src={viaja} alt='viaja'/>  */}  
                                            <div className='informacion'></div>  
                                        </div>
                                        
                                    </ul>
                                </div>
                                )}
                                </li>
                            <li className='itinerario_option'><Link to="/viaje-en-curso">{t('opc8')} </Link></li>
                        </ul>
                    </div>                    

                    <div className='header-item-list'>
                        <ul>
                           
                            <li><Link to="/soluciones-logisticas" className='btn-carga'><img src={carga} alt='sección de carga'/>  
                                <label>{t('opc6')}</label></Link>
                            </li>   
                               
                           {/* <li>                                                        
                             <label style={{display:'flex'}} onClick={() => changeLanguage('es')}><i class="fi fi-rs-globe"></i> {currentLanguage.toUpperCase()}    <i class="fi fi-rr-caret-down"></i>    </label>
                                <ul className='submenu-item'>                                
                                    <li onClick={() => changeLanguage('es')}>ES </li>     
                                    <li onClick={() => changeLanguage('en')}>EN </li>
                                    <li></li>
                                    <li onClick={() => changeLanguage('fr')}>FR </li>                      
                                </ul>
                            </li>*/}

                            <li  onClick={() => toggleSubmenu(3)}> <label style={{display:'flex', fontSize: '14px'}} onClick={() => changeLanguage('es')}><i class="fi fi-rs-globe" style={{marginRight:'4px'}}></i> {currentLanguage.toUpperCase()}    <i class="fi fi-br-angle-small-down" ></i>    </label> 
                                {isSubmenu === 3 &&(
                                    <>                                    
                                    <ul className='submenu-item idioma'>                                
                                        <li onClick={() => changeLanguage('es')}>ES </li>     
                                        <li onClick={() => changeLanguage('en')}>EN </li>
                                        <li></li>
                                        <li onClick={() => changeLanguage('fr')}>FR </li>                      
                                    </ul>                                
                                </>
                                )}
                               
                            </li>
                            
                            
                            <li className='btn-primary'  onClick={toggleLateralMenu}>                                
                                {
                                    lateralMenu ? (
                                        <i class="fi fi-rs-cross"></i>
                                    ):(
                                        <i class="fi fi-rs-burger-menu"></i>
                                    )
                                }
                              
                            </li>
                           
                            <li>
                                <button className='btn-secondary' onClick={toggleMenuExpanded} aria-label="menu lateral">
                                    <i class="fi fi-rs-apps"></i>
                                </button>                                
                            </li>
                           
                        </ul>
                    </div>
                    
                </div>
           </div>
        </div>
    </header>

    {/* Menu lateral DESKTOP*/}
    <aside className={`sidebar ${isActive ? "show" : null}`}>
        <div className='boxSidebar'>
            <div className='boxAsidebar'>
                <div className='btnCerrar'> 
                    <button onClick={toggleMenuExpanded}  className="navbar-toggle " id="toggleButton" aria-label="menu lateral">                            
                        {/*<i className="fi fi-rr-cross-circle"></i>*/}
                        <i class="fi fi-br-cross"></i>
                    </button>
                </div>
                <div className='blockAsidebar_first'>
                    <ul>                                       
                        <li className='block'><Link to="/nosotros">{t('lateral_menu1')} </Link>
                            <ul>
                                <li><Link to="/nosotros" onClick={toggleMenuExpanded}>{t('lateral_menu2')} </Link></li>
                                {/*<li><Link to="/puertos">Puertos </Link></li>*/}
                                <li><Link to="/flota" onClick={toggleMenuExpanded}>{t('lateral_menu3')}</Link></li>                                              
                                <li><Link to="/certificaciones" onClick={toggleMenuExpanded}>{t('lateral_menu4')}  </Link></li>                                       
                                {/*<li><Link to="/itinerarioprueba" onClick={toggleMenuExpanded}>Viaje en curso </Link></li> */}
                            </ul>
                        </li>  
                        <li className='block'><Link to="/soluciones-logisticas">{t('opc6')}</Link>
                            <ul>
                                <li><Link to="/soluciones-logisticas" onClick={toggleMenuExpanded}>{t('lateral_menu6')}</Link></li>
                               {/*} <li><Link to="/maritimo" onClick={toggleMenuExpanded}>Marítimo </Link></li>
                                <li><Link to="/terrestre" onClick={toggleMenuExpanded}>Terrestre </Link></li>
                                <li><Link to="/multimodal" onClick={toggleMenuExpanded}>Multimodal </Link></li>
                                <li><Link to="/integración-logística" onClick={toggleMenuExpanded}>Integración Logística </Link></li>*/}
                            </ul>
                        </li>  
                        {/* 
                        <li className='block'><a href="?">Soluciones digitales</a>
                            <ul>
                                <li><a href='?'>Marketplace</a></li>
                                <li><a href='?'>Rastreo</a></li>                                                    
                            </ul>
                        </li> 
                        */}
                        <li className='block'><a href="https://booking.bajaferries.com.mx/es/cuenta/" target="_blank" rel="noopener noreferrer">{t('lateral_menu7')}</a>
                            <ul>
                                <li><Link to="/noticias" onClick={toggleMenuExpanded}>{t('lateral_menu8')}</Link></li>
                            </ul>
                        </li>
                        <li className='block'><a href="?">{t('lateral_menu9')}</a>
                            <ul>
                                <li> <a href="https://booking.bajaferries.com.mx/es/cuenta/" target="_blank" rel="noopener noreferrer">{t('lateral_menu10')}</a></li>                                
                            </ul>
                        </li>
                        <li className='block'><a href="?">Términos y condiciones promociones</a>
                            <ul>
                                <li> <a href="https://www.bajaferries.com.mx/Terminos_y_Condiciones_Asiento_Dorado.pdf" target="_blank" rel="noopener noreferrer">Asiento Dorado <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li>                                
                                <li> <a href="https://www.bajaferries.com.mx/tyc/Terminos_y_condiciones_pelota_a_bordo.pdf" target="_blank" rel="noopener noreferrer">Pelota a bordo <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li> 
                                <li> <a href="https://www.bajaferries.com.mx/tyc/TyC-Swap-de-barcos.pdf" target="_blank" rel="noopener noreferrer">Swap de barcos <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li> 

                            </ul>
                        </li>
                       
                        {/*                   
                        <li className='block'><a href="?">Prensa</a>
                            <ul>
                                <li><Link to="/kit-de-comunicacion" onClick={toggleMenuExpanded}>Contacto de agencia</Link></li>
                            </ul>
                        </li>
                        */}
                    </ul>
                </div>
                <div className='blockAsidebar_second'>
                    <ul>
                    {/*
                    <li className='block'><a href="?">RSE</a>
                        <ul>
                            <li><a href='?'>Modelo de sustentabilidad</a></li>
                            <li><a href='?'>Programas</a></li>
                            <li><a href='?'>Voluntariado</a></li>
                        </ul>
                    </li>  
                    */}
                    <li className='block'><a href='?'>{t('lateral_menu20')}</a>                                           
                        <ul>
                            <li><Link to="/contacto" onClick={toggleMenuExpanded}>{t('submenu6')} </Link></li>  
                            <li><Link to="/preguntas-frecuentes" onClick={toggleMenuExpanded}>{t('submenu4')} </Link></li>                              
                            <li><a href="https://bo-latam.opinat.com/index.php/survey/noapiqr?user=edorantes.mexico&pass=e3f391ec274cd03488365c20827762e3dc893500&nif=COLR039&centro=7888&campanya=6711&oleada=100982&idm=es" target="_blank" rel="noopener noreferrer">{t('lateral_menu13')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li>
                        </ul>                                     
                    </li>
                    <li className='block'><a href="?"> {t('lateral_menu14')} </a>                      
                        <ul>                            
                            <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu15')}<i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>
                            <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu16')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>                                                                                                               
                                                                                                              
                        </ul>
                    </li>
                    
                    {/*<li className='block'><Link to="/login-gobernanza" onClick={toggleMenuExpanded}>Gobernanza </Link>
                        <ul>
                            <li>
                                <Link to="/login-gobernanza" onClick={toggleMenuExpanded}>Login</Link>
                            </li>                                                                                    
                        </ul>
                    </li>*/}
                    <li className='block'><Link to="/login-gobernanza" onClick={toggleMenuExpanded}>{t('lateral_menu17')} </Link>
                        <ul>
                            <li>
                                <a href="https://facturacion.bajaferries.com/" target="_blank" rel="noopener noreferrer">{t('lateral_menu18')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>    
                            </li>  
                            <li>
                                <a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu19')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>    
                            </li>                                                                                    
                        </ul>
                    </li>  

                                              
                    </ul>  

                     
                                                        
                    
                </div>

                <div className='asidebar_icons_socials'>    
                    <a href="https://www.facebook.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={facebook_icon}  alt='facebook baja ferries'/></a> 
                    <a href="https://www.instagram.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={instagram_icon}  alt='instagram baja ferries'/></a> 
                    <a href="https://open.spotify.com/user/in0rh2go0af0k6asr46bzxun7" target="_blank" rel="noopener noreferrer"><img src={spotify_icon}  alt='spotify baja ferries'/></a> 
                    <a href="https://x.com/bajaferries" target="_blank" rel="noopener noreferrer"><img src={twitter_icon}  alt='twitter baja ferries'/></a> 
                    <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer"><img src={whatsapp_icon}  alt='whatsapp baja ferries'/></a> 
                    <a href="https://www.youtube.com/@bajaferries2914" target="_blank" rel="noopener noreferrer"><img src={youtube_icon}  alt='youtube baja ferries'/></a>                                                                                
                </div>
            
            </div>
                        
        </div>                                                    
    </aside>

    {/* Menu lateral CELULAR*/}
    <aside className={`lateral ${lateralMenu ? "show" : null}`}>
        <div className='lateral-content '>
            <div className='container'>
                <div className='box-sidebar'>              
                    <div className='block-sidebar'>
                        <ul>     
                            <li><Link to="/rutas_horario" onClick={toggleLateralMenu}><div><img src={rutasyhorarios} alt=''/>{t('opc1')}</div></Link></li>
                            <li><Link to="/tarifas" onClick={toggleLateralMenu}><div><img src={tarifas} alt=''/>{t('opc2')}</div></Link></li>
                            <li><Link to="/promociones" onClick={toggleLateralMenu}><div><img src={promociones} alt=''/>{t('opc3')}</div> </Link></li>  
                            <li  onClick={() => toggleDropdown(1)}><Link ><div><img src={viaja} alt=''/>{t('opc4')}</div> <i class="fi fi-br-angle-small-down" ></i> </Link>                                
                     
                                {dropdown === 1 &&(
                                    <div>
                                        <ul>
                                            <li><Link to="/destinos" onClick={toggleLateralMenu}><div>{t('submenu1')}</div></Link></li>
                                            <li><Link to="/viaje-en-grupo" onClick={toggleLateralMenu}><div>{t('submenu2')}</div></Link></li>                                        
                                            <li><Link to="/conecta-tu-trayecto" onClick={toggleLateralMenu}><div>Conecta tu viaje</div></Link></li>    
                                            {/*<li><Link to="/bf-pass" onClick={toggleLateralMenu}><div  className='nuevo-item'>BF Pass</div></Link></li>    */}
                                        </ul>
                                    </div>
                                )}
                            </li>
                            <li><Link onClick={() => toggleDropdown(2)} ><div><img src={informacion} alt=''/>{t('opc5')} </div>  <i class="fi fi-br-angle-small-down"></i></Link>
                           
                            {dropdown === 2 &&(
                                <div>
                                    <ul>
                                        <li><Link to="/prepara-tu-viaje" onClick={toggleLateralMenu}>{t('submenu3')} </Link></li>
                                        <li><Link to="/preguntas-frecuentes" onClick={toggleLateralMenu}>{t('submenu4')}  </Link></li>
                                        <li><Link to="/flota" onClick={toggleLateralMenu}>{t('submenu5')} </Link></li>
                                        <li><Link to="/contacto" onClick={toggleLateralMenu}>{t('submenu6')} </Link></li>                                                                                 
                                    </ul>
                                </div>
                            )}
                            </li>
                            <li><Link to="/viaje-en-curso" onClick={toggleLateralMenu}><div><img src={itinerario} alt=''/>{t('opc8')} </div>  </Link></li>                                                 
                            <li><Link to="/soluciones-logisticas" onClick={toggleLateralMenu}><div><img src={cargaImg} alt=''/>{t('opc6')} </div>  <i class="fi fi-br-angle-small-right"></i> </Link></li>  
   
                        </ul>
                    </div>
                    <div className='block-sidebar'>
                        <ul>
                            <li><Link onClick={() => toggleDropdown(3)}>{t('lateral_menu1')}  <i class="fi fi-br-angle-small-down"></i></Link>
                            {dropdown === 3 &&(
                                <div>
                                    <ul>                                        
                                        <li><Link to="/nosotros" onClick={toggleLateralMenu}>{t('lateral_menu2')} </Link></li>                                     
                                        <li><Link to="/flota" onClick={toggleLateralMenu}>{t('lateral_menu3')}  </Link></li>
                                        <li><Link to="/certificaciones" onClick={toggleLateralMenu}>{t('lateral_menu4')}  </Link></li>
                                    </ul>
                                </div>
                            )}
                            </li>  
                          {/*}  <li><Link  onClick={() => toggleDropdown(4)}>{t('opc6')} <i class="fi fi-br-angle-small-right"></i></Link>
                            {dropdown === 4 &&(
                                <div>
                                    <ul>                                        
                                        <li><Link to="/soluciones-logisticas">{t('lateral_menu6')} </Link></li>                                     
                                                                                                                       
                                    </ul>
                                </div>
                            )}
                            </li>                    
                             
                            <li><a href="?">{t('opc7')} <i class="fi fi-br-angle-small-down"></i></a></li>  */}     
                            <li><Link  onClick={() => toggleDropdown(5)}>{t('lateral_menu20')}<i class="fi fi-br-angle-small-down"></i></Link> 
                            {dropdown === 5 &&(
                                <div>
                                    <ul>                                        
                                        <li><Link to="/contacto" onClick={toggleLateralMenu}>{t('lateral_menu11')} </Link></li>
                                        <li><Link to="/preguntas-frecuentes" onClick={toggleLateralMenu}>{t('lateral_menu12')}  </Link></li>                                        
                                        <li><a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu13')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a></li>                                                                                                                                                            
                                    </ul>
                                </div>
                            )}</li>     
                            {/*<li><Link onClick={() => toggleDropdown(6)}> {t('lateral_menu14')} <i class="fi fi-br-angle-small-down"></i></Link> 
                            {dropdown === 6 &&(
                                <div>
                                    <ul>             
                                        <li><a href="https://www.eticabajaferries.com.mx/c%C3%B3digo-de-%C3%A9tica/" target="_blank" rel="noopener noreferrer">{t('lateral_menu15')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>
                                        <li><a href="https://www.eticabajaferries.com.mx/denuncias/" target="_blank" rel="noopener noreferrer">{t('lateral_menu16')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>                                                                                                                                                                                                                    
                                    </ul>
                                </div>
                            )}
                            </li>*/} 
                            <li><Link onClick={() => toggleDropdown(7)}>{t('lateral_menu17')} <i class="fi fi-br-angle-small-down"></i></Link>
                            {dropdown === 7 &&(
                                <div>
                                    <ul>
                                        <li><a href="https://facturacion.bajaferries.com/" target="_blank" rel="noopener noreferrer">{t('lateral_menu18')} <i class="fi fi-rs-arrow-up-right-from-square"></i> </a>  </li>
                                        <li><a href="http://proveedores.bajaferries.com/ProveedoresLogin.aspx" target="_blank" rel="noopener noreferrer">{t('lateral_menu19')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a> </li>                                                                               
                                         <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu15')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>
                                        <li><a href="https://eticabajaferries.lineaetica.com.mx/" target="_blank" rel="noopener noreferrer">{t('lateral_menu16')} <i class="fi fi-rs-arrow-up-right-from-square"></i></a>   </li>                                                                                                                                                                                                                    
                                    </ul>
                                </div>
                            )}
                            </li>   
                            <li><Link to="/noticias" onClick={toggleLateralMenu}>{t('lateral_menu8')} </Link> </li>
                            <li><a href="https://booking.bajaferries.com.mx/es/cuenta/">{t('lateral_menu9')}</a></li>                                                                                      
                        </ul>
                    </div>
                    <div className='btn-idioma-option'>
                        <button onClick={() => changeLanguage('es')} className={currentLanguage === 'es' ? 'active-language' : ''}>Es</button>
                        <button onClick={() => changeLanguage('en')} className={currentLanguage === 'en' ? 'active-language' : ''}>En</button>
                        <button onClick={() => changeLanguage('fr')} className={currentLanguage === 'fr' ? 'active-language' : ''}>Fr</button>
                    </div>                 

                    <div className='sidebar_icons_socials'>    
                        <a href="https://www.facebook.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={facebook_icon_blue}  alt='facebook baja ferries'/></a> 
                        <a href="https://www.instagram.com/bajaferriesoficial/" target="_blank" rel="noopener noreferrer"><img src={instagram_icon_blue}  alt='instagram baja ferries'/></a> 
                        <a href="https://open.spotify.com/user/in0rh2go0af0k6asr46bzxun7" target="_blank" rel="noopener noreferrer"><img src={spotify_icon_blue}  alt='spotify baja ferries'/></a> 
                        <a href="https://x.com/bajaferries" target="_blank" rel="noopener noreferrer"><img src={twitter_icon_blue}  alt='twitter baja ferries'/></a> 
                        <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer"><img src={whatsapp_icon_blue}  alt='whatsapp baja ferries'/></a> 
                        <a href="https://www.youtube.com/@bajaferries2914" target="_blank" rel="noopener noreferrer"><img src={youtube_icon_blue}  alt='youtube baja ferries'/></a>                                                                                       
                    </div>
                </div>
            </div>   
        </div>                                                 
    </aside>

    {/* Overlay */}
    <div className={`overlay ${isSubmenu || isActive || lateralMenu ? 'overlay-active' : ''}`}  onClick={closeSubmenu}></div>

    <Outlet />
    
    </>
  )
}
